module.exports = __webpack_public_path__ + "static/media/linkedin_dp_psd9.b8de9345.jpg";